import { createPinia } from 'pinia'
import { setupLayouts } from 'virtual:generated-layouts'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'

import App from './App.vue'

import './style.css'
import 'virtual:uno.css'
import './assets/index.css'
import '@unocss/reset/normalize.css'
import '@unocss/reset/tailwind.css'
import 'vue-sonner/style.css'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/avatars',
    },
    ...setupLayouts(routes),
  ],
})

const pinia = createPinia()

createApp(App)
  .use(router)
  .use(pinia)
  .mount('#app')
